module.exports = __webpack_public_path__ + "img/petstairs29.a69b419c.jpg";